/**
 * Polyfill for Array.prototype.toSorted and Array.prototype.toSortedBy
 *
 * These methods were introduced in:
 * - Chrome 110+
 * - Firefox 115+
 * - Safari 16+
 *
 * This polyfill ensures compatibility with older browsers.
 */

// Check if toSorted is already supported natively
if (!Array.prototype.toSorted) {
  /**
   * Creates a new array with all elements sorted in ascending order.
   * The original array is not modified.
   *
   * @param compareFn - Optional function that defines the sort order
   * @returns A new array with the elements sorted
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (Array.prototype as any).toSorted = function <T>(this: T[], compareFn?: (a: T, b: T) => number): T[] {
    // Create a copy of the array and sort it
    return [...this].sort(compareFn);
  };
}
// Type declarations are in array-tosorted.d.ts
